import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable}     from 'rxjs/Observable';
import {Notification} from './notification';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class NotificationsService {

    private _notificationsUrl = '/notificationData/actives';
    private serverURL: string; 

    constructor(private http: Http) {
        this.serverURL = json.api_url;
    }

    getNotifications():Promise<any> {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if (token) {

            authHeader.append('Authorization', 'Bearer ' + token);

        }   

        let options = new RequestOptions({ headers: authHeader, body: "" });

        return this.http.get(this.serverURL + this._notificationsUrl, options).toPromise().then(res => { 
    
            if (JSON.parse(res.text()).code == 1) {

                return JSON.parse(res.text()).rows;

            } else {

                return null;

            }            
        
        }, this.handleError);
    }    

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }

    private serializeObj(obj: any) {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/notifications/notifications.service.ts
 **/